import { Controller } from 'front-end-core/core/Router'
import Main from './Main'
import { RELATED } from 'constants/controllers'

// TODO: can delete ?
export default new Controller({
  name: RELATED,
  route: '(:flavour/)related',
  controller (Router, evt, render) {
    render(
      { Main },
      {},
      evt.params
    )

    return evt.url
  }
})
